import * as React from 'react';
import { assign as _assign} from 'lodash';
import { connect } from 'react-redux';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';

export interface GroupsDispatcherProps {
  userData: GlobalPrivateState['userData'];
  dispatch: any;
  queryState: GlobalPrivateState['queryState'];
  groups: GlobalPrivateState['groups'];
  user: GlobalPrivateState['user'];
  parentId?: string;
}

const dispatchKey = 'groups';

class GroupsDispatcherContainer extends React.Component<GroupsDispatcherProps, any> {
  constructor(props: GroupsDispatcherProps) {
    super(props);
  }

  componentDidMount() {
    this.dispatchGroups();
  }

  public render() {
    return null;
  }

  componentDidUpdate(prevProps: GroupsDispatcherProps) {
    // if (this.props.parentId !== prevProps.parentId) {
    //   this.dispatchGroups();
    // }
  }

  private dispatchGroups() {
    // if (!this.props.user.result) { return }


    const queryParams: any = {
      where: { }, // userId: this.props.user.result.id
      order: 'updated_at DESC'
    };
    
    // console.log('this.props.queryState.params.folderId', this.props.queryState.params.folderId);
    // if (this.props.parentId) {
    //   queryParams.where.parentId = this.props.parentId;
    // }

    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      dispatchKey, {
        url: `/Groups/my-groups`,
        queryParams
      },
      true
    ));
  }
}

export const GroupsDispatcher = connect((state: GlobalPrivateState) => ({
  configurations: state.configurations,
  queryState: state.queryState,
  groups: state.groups,
  userData: state.userData,
  user: state.user,
}))(GroupsDispatcherContainer);
